module.exports = __webpack_public_path__ + "static/logo-a7aa6faa974ee9c4d08de8095f81f521.png";